import React from 'react';

const LegalDisclaimer = () => {
    return (
        <section className="terms">
            <div className="row">
                <h2>Legal Disclaimer</h2>
            </div>

            <div className="row content">
                <div>
                    <p><strong>For Informational Purposes Only</strong></p>
                    <p>
                        All content on this website, including text, graphics, and images, is for informational purposes only. It is not intended to be a substitute for professional medical advice, diagnosis, or treatment. 
                    </p>

                    <p><strong>Not a Dispensary</strong></p>
                    <p>
                        merigold.care does not manufacture, sell, or deliver products. All products are warehoused and shipped by a third-party, legally licensed logistics entity. Any claims regarding product efficacy or side effects are the responsibility of the owner and the third-party dispensing facility.
                    </p>

                    <p><strong>Limitation of Liability</strong></p>
                    <p>
                        The owner of this landing page shall not be held liable for any damages, injuries, or losses resulting from the use of the products dispensed by third parties or the advice provided by independent affiliates. Your use of this platform constitutes an agreement to indemnify and hold harmless the landing page owner from any legal claims arising from third-party fulfillment or affiliate support.
                    </p>
                    <p>
merigold.care disclaims all liability for physical, financial, or data-related harms arising from the clinical decisions of physicians, or any unauthorized representations made by independent affiliates. By using this platform, you acknowledge that merigold.care is an administrative intermediary.
                    </p>

                    <p>
                        By using this platform, you acknowledge that merigold.care acts solely as an administrative intermediary 
                        and is not a party to any medical or pharmaceutical transaction.
                    </p>
                </div>
            </div>
        </section>
    );
};

export default LegalDisclaimer;